import { computed, makeObservable } from 'mobx'

import { ModelWithPolicy } from 'modules/core/lib/modelWithPolicy'
import GoalConfigPolicy from 'modules/core/store/models/policies/GoalConfigPolicy'

export const TYPES = {
  numeric: 'numeric',
  none: 'empty',
}

export const STATUS = {
  active: 'active',
  closed: 'closed',
}

interface IGoalConfig {
  [key: string]: any
}

class GoalConfig extends ModelWithPolicy<IGoalConfig> {
  constructor(attr: IGoalConfig = {}) {
    super(attr)
    makeObservable(this, {
      isNumeric: computed,
      isFinished: computed,
      isActive: computed,
    })
  }

  static urlRoot() {
    return '/goals/goals_config'
  }

  get policy() {
    return new GoalConfigPolicy(this)
  }

  get isNumeric(): boolean {
    return this.attributes.goal_type === TYPES.numeric
  }

  get isFinished(): boolean {
    return this.attributes.status === STATUS.closed
  }

  get isActive(): boolean {
    return this.attributes.status === STATUS.active
  }
}

export default GoalConfig
